import { apiGet } from './client';

export function listDiseaseCategories() {
  return apiGet('/api/v1/disease-categories');
}

export function listSamplePresets() {
  return apiGet('/api/v1/sample-presets');
}

export function listReferenceDeals() {
  return apiGet('/api/v1/reference-deals');
}

export function matchReferenceDeals({ disease, dataTypes, samples }) {
  const params = new URLSearchParams();
  if (disease) params.set('disease', disease);
  if (dataTypes && dataTypes.length) params.set('data_types', dataTypes.join(','));
  if (samples != null) params.set('samples', String(samples));
  const qs = params.toString();
  return apiGet(`/api/v1/reference-deals/match${qs ? `?${qs}` : ''}`);
}
